import { useEffect, useRef } from "react";
import api from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      window.location.href = "/login";
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then(() => {
        window.history.replaceState(null, "", "/");
        window.location.href = "/";
      })
      .catch(() => {
        window.location.href = "/login";
      });
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F172A] gap-4">
      <div className="h-10 w-10 rounded-full border-2 border-[#C9A24B] border-t-transparent animate-spin" />
      <p className="text-slate-400 text-sm">Signing you in…</p>
    </div>
  );
}
